export enum MessageBoxTypes {
  /**
   * @deprecated please use `MessageBoxTypes.Confirm` instead
   */
  CONFIRM = 'CONFIRM',
  /**
   * @deprecated please use `MessageBoxTypes.Error` instead
   */
  ERROR = 'ERROR',
  /**
   * @deprecated please use `MessageBoxTypes.Information` instead
   */
  INFORMATION = 'INFORMATION',
  /**
   * @deprecated please use `MessageBoxTypes.Success` instead
   */
  SUCCESS = 'SUCCESS',
  /**
   * @deprecated please use `MessageBoxTypes.Warning` instead
   */
  WARNING = 'WARNING',
  /**
   * @deprecated please use `MessageBoxTypes.Highlight` instead
   */
  HIGHLIGHT = 'HIGHLIGHT',

  Confirm = 'Confirm',
  Error = 'Error',
  Information = 'Information',
  Success = 'Success',
  Warning = 'Warning',
  Highlight = 'Highlight'
}
